const env = process.env.REACT_APP_ENVIRONMENT || 'preprod'
const config = require(`./environments/${env}`)
config.env = env
config.GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyCpBkXRhjaUBiWTjQFowaRvcnOisw0a3KQ'
config.GOOGLE_AUTH_KEY = process.env.REACT_APP_GOOGLE_AUTH_KEY
config.FB_KEY = process.env.REACT_APP_FB_LOGIN || '2077166299156807'

module.exports = config
